import { render } from "./Accueil.vue?vue&type=template&id=cbf94f62"
import script from "./Accueil.ts?vue&type=script&lang=js"
export * from "./Accueil.ts?vue&type=script&lang=js"

import "./Accueil.vue?vue&type=style&index=0&id=cbf94f62&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__